import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

import Logo from '../resources/assets/logo.png';

export default function InputBox(props) {
  const style = Object.assign({
    backgroundColor: 'rgb(77, 77, 77, 0.8)', 
    border: '7px solid rgb(189, 148, 94)',
    borderRadius: '25px',
    display: 'flex',
    marginTop: '50px',
    minHeight: '350px',
    minWidth: '400px'
    }, props.style);
  return (<>
    <div style={style}>
      <Container >
        <Row className="justify-content-md-center">
          <img src={Logo} alt='Payfacto' style={{ marginTop: '20px', marginBottom: '30px' }} />
        </Row>
        <Row className="justify-content-sm-center">
          {props.children}
        </Row>
      </Container>
    </div>
  </>);
}